import { useOutletContext } from 'react-router-dom';
import {
  SelectedTranscriptsSummary,
  Transcript,
  TranscripsCategoriesKeys,
} from '../../interfaces/TranscriptsInterface';
import { AxiosError } from 'axios';

interface OutletContextValues {
  selectedTranscriptsSummaryResponse: {
    selectedTranscriptsError: Error | AxiosError<unknown, any> | null;
    selectedTranscriptsSummary: SelectedTranscriptsSummary;
    setSelectedTranscriptsSummary: React.Dispatch<React.SetStateAction<SelectedTranscriptsSummary>>;
  };
  previewTranscriptIndex: number;
  setPreviewTranscriptIndex: (id: number) => void;
  selectionCounts: { [key: string]: number };
  detailsTranscripts: Transcript[];
  updateDetailsTranscripts: (newTranscripts: Transcript[]) => void;
  detailsCategory: TranscripsCategoriesKeys;
  updateDetailsCategory: (newCategory: TranscripsCategoriesKeys) => void;
  detailsLinks: {
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
  updateDetailsLinks: (detailsLinks: { hasPreviousPage: boolean; hasNextPage: boolean }) => void;
  refreshData: () => void;
  workflowStatus: string | null;
  refreshWorkflowStatus: () => Promise<void>;
}

export function useTranscriptSelectionOutletContext() {
  return useOutletContext<OutletContextValues>();
}

export type { OutletContextValues };
